import { ControlePrestaties } from '../client/procescontroleclient';
import Table from "../components/tables/Table";
import { TableType } from '../Types';

interface ProcesControlePrestatiesKubusProps {
  name: string;
  data: ControlePrestaties[];
}

export default function ProcesControlePrestatiesKubus(props: ProcesControlePrestatiesKubusProps) {

  return (
          <div key={props.name}>
            <Table style={{
              width: '100%'
            }} tableType={TableType.Default} filterheader stickymodal>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', width: "5%" }} scope="col">{props.name}</th>
                  <th style={{ textAlign: 'center' }} scope="col">Regels Totaal</th>
                  <th style={{ textAlign: 'center' }} scope="col">Regels Gevuld</th>
                  <th style={{ textAlign: 'center' }} scope="col">Score Gevuld</th>
                  <th style={{ textAlign: 'center' }} scope="col">Regels Ingepakt</th>
                  <th style={{ textAlign: 'center' }} scope="col">Score Ingepakt</th>
                </tr>
              </thead>
              <tbody>
                {props.data?.map((row: ControlePrestaties) => {
                  return (
                    <tr key={row.rol}>
                      <td>{row.rol}</td>
                      <td style={{ textAlign: 'center' }}>{row.regelsTotaal}</td>
                      <td style={{ textAlign: 'center' }}>{row.regelsVerwerkt}</td>
                      <td style={{ textAlign: 'center' }}>{row.score}%</td>
                      <td style={{ textAlign: 'center' }}>{row.regelsIngepakt}</td>
                      <td style={{ textAlign: 'center' }}>{row.scoreIngepakt}%</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </div>
    );
}